import {
  useFacetContext,
  useFilterSuggestionsContext,
} from '../../../context/PlpContext';

export const useFilterSuggestionsData = () => {
  const filterSuggestions = useFilterSuggestionsContext();
  const facetContext = useFacetContext();

  return {
    filterSuggestions,
    facetContext,
  };
};
